export const FCA_PATH = 'corporate-account';
export const FCA_DASHBOARD_PATH = `${FCA_PATH}/all`;
export const FLASH_DRIVE_ORDERS_PATH = 'archive-orders/all';
export const ACCOUNT_ADMIN_PATH = 'admin';
export const PROJECTS_PATH = 'projects/all';
export const SIGNIN_OIDC_PATH = 'signin-oidc';
export const SIGNOUT_OIDC_PATH = 'signout-oidc';
